import { useCallback } from 'react';
import { FormikHelpers } from 'formik';
import { useQueryClient } from '@tanstack/react-query';

import { useProsforaAuctionVolumes } from 'api';
import { useDispatch } from 'store';
import { login } from 'store/auth';
import FormSubmitError from 'errors/FormSubmitError';

import { LoginFormData } from './useInitialValues';

const useLoginSubmit = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useCallback(
    async (values: LoginFormData, helpers: FormikHelpers<LoginFormData>) => {
      try {
        await dispatch(login(values)).unwrap();

        await queryClient.invalidateQueries({ queryKey: useProsforaAuctionVolumes.getQueryKey() });
        await queryClient.refetchQueries({ queryKey: useProsforaAuctionVolumes.getQueryKey() });
      } catch (e) {
        if (FormSubmitError.isInstance(e)) {
          helpers.setFieldError('password', (e as FormSubmitError).message);
        } else {
          console.error(e);
        }
      }
    },
    [dispatch, queryClient],
  );
};

export default useLoginSubmit;
